export default "__VITE_ASSET__PTWIZ1ET__"